<template>
  <div class="carousel">
    <!-- 父容器：row 栅格行 -->
    <section class="">
      <powerText />
      <div class="right entext col-lg-12">
        <video
          ref="videoRef"
          class="video"
          muted
          loop
          autoplay
          playsinline
          webkit-playsinline
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          poster="@/assets/images/carousel01.gif"
          style="width: 98%; height: auto; border-radius: 10px"
        >
          <source src="@/assets/images/carousel2.mp4" type="video/mp4" />
          您的浏览器不支持视频播放
        </video>
      </div>

      <!-- <div class="left entext col-lg-12">
        <video
          ref="videoRef"
          class="video"
          muted
          loop
          autoplay
          playsinline
          webkit-playsinline
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          poster="@/assets/images/carousel0.gif"
          style="width: 98%; height: auto; border-radius: 10px"
        >
          <source src="@/assets/images/carousel5.mp4" type="video/mp4" />
          您的浏览器不支持视频播放
        </video>
      </div> -->
    </section>
  </div>
</template>

<script>
import powerText from '@/components/powerText.vue';

export default {
  name: 'carousel',
  components: {
    powerText,
  },
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.powerText {
  padding: 3rem 0 0 0;
}

.left img {
  border-radius: 10px;
}
.right {
  padding: 20px 0 0 0;
}
</style>
